<template>
    <span class="loader"></span>
</template>

<script>
export default {
    name: 'MobileSpinner',
};
</script>

<style scoped lang="scss">
.loader {
    width: 28px;
    height: 28px;
    border: 4px solid #00458D;
    border-bottom-color: transparent;
    border-radius: 50%;
    display: inline-block;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
}

@keyframes rotation {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
